module.exports = __webpack_public_path__ + "img/ef7a419.png";